module.exports = __webpack_public_path__ + "static/media/map-image.f40ed5b1.png";